export default __webpack_public_path__ + "static/media/average_calls_per_user.c891b21d.svg";